import React from 'react';
import PropTypes from 'prop-types';
import { Components, Utils, translate } from 'versafleet-core';
import MeasurementModule from 'modules/measurement';
import JobModuleCustomAddress from 'modules/job/customAddress';
import JobModuleCustomDateTime from 'modules/job/customDateTime';
import { connect } from 'react-redux';
import ReduxActions from 'reduxActions';
import addOnsSettings from 'modules/addOns/addOnsConstants';
import CustomInfoEdit from './customInfoEdit';

class TaskEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAttachmentInput: false,
      openEpodAttachmentInput: false,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch(ReduxActions.ourLocation.fetchList());
    const billingAccountId = this.props.form.billing_account_id;
    if (billingAccountId) {
      this.props.dispatch(ReduxActions.billingAccount.fetch(billingAccountId));
    }
    this.props.dispatch(ReduxActions.versadriveSetting.fetchVersadriveSetting());
  }

  componentDidUpdate(prevProps) {
    // Auto apply skills from billing account on billing account change
    if (
      prevProps.billingAccounts !== this.props.billingAccounts
        && this.props.form?.billing_account_id
        && this.props.billingAccounts[this.props.form?.billing_account_id]
    ) {
      const billingAccount = this.props.billingAccounts[this.props.form.billing_account_id];

      if (this._isSkillsSubscribed()) {
        this.props.onFormChange(
          'driver_skill_list',
          (this.props.form.driver_skill_list || []).concat(
            (billingAccount.driver_skills || [])
              .map(skill => skill.name)
              .filter(skill => !(this.props.form.driver_skill_list || []).includes(skill)),
          ),
        );

        this.props.onFormChange(
          'vehicle_skill_list',
          (this.props.form.vehicle_skill_list || []).concat(
            (billingAccount.vehicle_skills || [])
              .map(skill => skill.name)
              .filter(skill => !(this.props.form.vehicle_skill_list || []).includes(skill)),
          ),
        );

        if (this._isPartsSubscribed()) {
          this.props.onFormChange(
            'vehicle_part_skill_list',
            (this.props.form.vehicle_part_skill_list || []).concat(
              (billingAccount.vehicle_part_skills || [])
                .map(skill => skill.name)
                .filter(skill => !(this.props.form.vehicle_part_skill_list || []).includes(skill)),
            ),
          );
        }
      }
    }

    // Remove auto applied skills from previous billing account on change
    if (
      prevProps.form?.billing_account_id !== this.props.form?.billing_account_id
        && prevProps.form?.billing_account_id
        && this.props.billingAccounts[prevProps.form?.billing_account_id]
    ) {
      const billingAccount = this.props.billingAccounts[prevProps.form.billing_account_id];

      if (this._isSkillsSubscribed()) {
        const skillsToRemove = {
          driverSkills: (billingAccount.driver_skills || []).map(skill => skill.name),
          vehicleSkills: (billingAccount.vehicle_skills || []).map(skill => skill.name),
          partSkills: (billingAccount.vehicle_part_skills || []).map(skill => skill.name),
        };

        this.props.onFormChange(
          'driver_skill_list',
          (this.props.form.driver_skill_list || [])
            .filter(skill => !skillsToRemove.driverSkills.includes(skill)),
        );

        this.props.onFormChange(
          'vehicle_skill_list',
          (this.props.form.vehicle_skill_list || [])
            .filter(skill => !skillsToRemove.vehicleSkills.includes(skill)),
        );

        if (this._isPartsSubscribed()) {
          this.props.onFormChange(
            'vehicle_part_skill_list',
            (this.props.form.vehicle_part_skill_list || [])
              .filter(skill => !skillsToRemove.partSkills.includes(skill)),
          );
        }
      }
    }
  }

  _isSkillsSubscribed() {
    return !!this.props.account?.addons_setting?.skills;
  }

  _isPartsSubscribed() {
    return !!this.props.account?.addons_setting?.parts_and_config;
  }

  _getAccountOptions() {
    let accountOptions = [];
    const customer = this.props.customer;

    if (customer && typeof customer.billing_accounts !== 'undefined') {
      accountOptions = customer.billing_accounts.map(account => ({
        value: account.id,
        text: account.name,
      }));
    }
    return accountOptions;
  }

  _getCustomFieldGroupOptions() {
    const options = [{
      value: null,
      text: 'No group',
    }];

    return options.concat(this.props.optionCustomFieldGroups.map(item => ({
      value: item.id,
      text: item.name,
    })));
  }

  _getAddresses() {
    const billingAccountId = this.props.form.billing_account_id;
    if (billingAccountId && this.props.billingAccounts[billingAccountId]) {
      return this.props.billingAccounts[billingAccountId].addresses
        .concat(this.props.ourLocations);
    }
    return this.props.ourLocations;
  }

  _renderCustomInfo() {
    let customFieldGroupId;
    if (this.props.isNewTask) {
      customFieldGroupId = this.props.form.custom_field_group_id;
    } else if (!Utils.Helper.isNullOrUndefined(this.props.data.custom_field_group)) {
      customFieldGroupId = this.props.data.custom_field_group.id;
    }

    if (this.props.account?.addons_setting?.custom_field === addOnsSettings.subscribed
      && (this.props.isNewTask || (!this.props.isNewTask && customFieldGroupId))) {
      return (
        <div>
          <CustomInfoEdit
            customFieldGroup={this.props.customFieldGroups[customFieldGroupId]}
            data={this.props.data}
            error={this.props.error.custom_fields || []}
            form={this.props.form}
            id={`${this.props.id}__custom-info`}
            isNewTask={this.props.isNewTask}
            onFormChange={(fieldName, value, i) => this.props.onFormChange(fieldName, value, i)}
            options={this._getCustomFieldGroupOptions()}
            strings={this.props.strings.Task.form.customInfo}
          />
          <Components.Form.Divider size="MEDIUM" />
        </div>
      );
    }

    return false;
  }

  _renderAdditionalInfo() {
    const {
      error, form, strings, myjobsSetting,
    } = this.props;
    const codInputTemplate = (
      <div>
        <Components.Form.Block
          fontColor="GREY"
          level={1}
        >
          {strings.Task.form.additionalInfo.cod.title}
        </Components.Form.Block>

        <Components.Form.Block
          fontColor="TEXT"
          level={2}
        >
          <Components.Input.Textbox
            error={error.expected_cod || []}
            id={`${this.props.id}__expected-cod`}
            onChange={value => this.props.onFormChange('expected_cod', value)}
            placeholder={strings.Task.form.additionalInfo.cod.expectedCODHint}
            value={form.expected_cod}
          />
        </Components.Form.Block>
        <Components.Form.Divider size="SMALL" />
      </div>
    );

    if (!myjobsSetting.show_additional_info) {
      return (
        <Components.Form.ExpandableContainer
          parent={(
            <Components.Form.Block iconClassName="versa-subject" iconText="" level={0}>
              {strings.Task.form.additionalInfo.title}
            </Components.Form.Block>
          )}
        >
          <Components.Form.Divider />
          {codInputTemplate}
        </Components.Form.ExpandableContainer>
      );
    }

    return (
      <Components.Form.ExpandableContainer
        parent={(
          <Components.Form.Block iconClassName="versa-subject" iconText="" level={0}>
            {strings.Task.form.additionalInfo.title}
          </Components.Form.Block>
        )}
      >
        <Components.Form.Divider />

        {myjobsSetting.show_note ? (
          <Components.Form.Block
            iconClassName="versa-note"
            iconText=""
            isInputIcon
            level={1}
          >
            <Components.Input.Textarea
              id={`${this.props.id}__remarks`}
              onChange={value => this.props.onFormChange('remarks', value)}
              placeholder={strings.Job.form.additionalInfo.remarksHint}
              value={form.remarks}
            />
          </Components.Form.Block>
        ) : false}

        {myjobsSetting.show_tags ? (
          <Components.Form.Block iconClassName="versa-tags" iconText="" isInputIcon level={1}>
            <Components.Input.Tag
              error={error.tag_list}
              id={`${this.props.id}__tag`}
              onChange={value => this.props.onFormChange('tag_list', value)}
              options={this.props.constant.tasks.tags.map(tag => ({
                text: tag,
                value: tag,
              }))}
              placeholder={strings.Job.form.additionalInfo.tagHint}
              value={form.tag_list}
            />
          </Components.Form.Block>
        ) : false}

        <Components.Form.Block iconClassName="versa-attachment" iconText="" isInputIcon level={1}>
          {Utils.UserAgentDetector.isMobileOrTablet() ? (
            <Components.Form.MobileAttachmentInput
              apiUrl={process.env.apiUrl}
              editable
              id={`${this.props.id}__mobile-attachment-input`}
              onButtonClick={() => this.setState({ openAttachmentInput: true })}
              onChange={value => this.props.onFormChange('photos_attributes', value)}
              onClose={() => this.setState({ openAttachmentInput: false })}
              open={this.state.openAttachmentInput}
              value={form.photos_attributes}
            />
          ) : (
            <Components.Form.AttachmentInput
              apiUrl={process.env.apiUrl}
              editable
              id={`${this.props.id}__attachment-input`}
              onButtonClick={() => this.setState({ openAttachmentInput: true })}
              onChange={value => this.props.onFormChange('photos_attributes', value)}
              onClose={() => this.setState({ openAttachmentInput: false })}
              open={this.state.openAttachmentInput}
              value={form.photos_attributes}
            />
          )}
        </Components.Form.Block>

        {this.props.account.addons_setting.use_own_epod === addOnsSettings.subscribed && (
          <React.Fragment>
            <Components.Form.Divider size="SMALL" />
            <Components.Form.Block iconClassName="versa-attachment" iconText="" isInputIcon level={1}>
              {Utils.UserAgentDetector.isMobileOrTablet() ? (
                <Components.Form.MobileAttachmentInput
                  apiUrl={process.env.apiUrl}
                  buttonLabel={strings.Task.form.additionalInfo.epodAttachment.button}
                  editable
                  emptyLabel={strings.Task.form.additionalInfo.epodAttachment.attachFile}
                  fileExtensions={['pdf']}
                  id={`${this.props.id}__mobile-epod-attachment-input`}
                  invalidTypeMessage={strings.Task.form.additionalInfo.epodAttachment.invalidType}
                  mimeTypes={['application/pdf']}
                  onButtonClick={() => this.setState({ openEpodAttachmentInput: true })}
                  onChange={value => this.props.onFormChange('epod_attachments_attributes', value)}
                  onClose={() => this.setState({ openEpodAttachmentInput: false })}
                  open={this.state.openEpodAttachmentInput}
                  title={strings.Task.form.additionalInfo.epodAttachment.title}
                  value={form.epod_attachments_attributes}
                />
              ) : (
                <Components.Form.AttachmentInput
                  apiUrl={process.env.apiUrl}
                  buttonLabel={strings.Task.form.additionalInfo.epodAttachment.button}
                  editable
                  emptyLabel={strings.Task.form.additionalInfo.epodAttachment.attachFile}
                  fileExtensions={['pdf']}
                  id={`${this.props.id}__epod-attachment-input`}
                  invalidTypeMessage={strings.Task.form.additionalInfo.epodAttachment.invalidType}
                  mimeTypes={['application/pdf']}
                  onButtonClick={() => this.setState({ openEpodAttachmentInput: true })}
                  onChange={value => this.props.onFormChange('epod_attachments_attributes', value)}
                  onClose={() => this.setState({ openEpodAttachmentInput: false })}
                  open={this.state.openEpodAttachmentInput}
                  title={strings.Task.form.additionalInfo.epodAttachment.title}
                  value={form.epod_attachments_attributes}
                />
              )}
            </Components.Form.Block>
          </React.Fragment>
        )}

        <Components.Form.Divider size="SMALL" />
        {codInputTemplate}

        {myjobsSetting.show_invoice_number && (
          <Components.Form.Block
            iconClassName="versa-invoice"
            iconText=""
            isInputIcon
            level={1}
          >
            <Components.Input.Textbox
              error={error.invoice_number || []}
              id={`${this.props.id}__invoice-number`}
              onChange={value => this.props.onFormChange('invoice_number', value)}
              placeholder={strings.Task.form.additionalInfo.invoiceNumberHint}
              value={form.invoice_number}
            />
          </Components.Form.Block>
        )}

        {myjobsSetting.show_price ? (
          <Components.Form.Block
            iconClassName="versa-money"
            iconText=""
            isInputIcon
            level={1}
          >
            <Components.Input.Textbox
              error={error.price || []}
              id={`${this.props.id}__price`}
              onChange={value => this.props.onFormChange('price', value)}
              placeholder={strings.Task.form.additionalInfo.priceHint}
              value={form.price}
            />
          </Components.Form.Block>
        ) : false}

        {myjobsSetting.show_tracking_id ? (
          <Components.Form.Block
            iconClassName="versa-trackid"
            iconText=""
            isInputIcon
            level={1}
          >
            <Components.Input.Textbox
              error={error.tracking_id || []}
              id={`${this.props.id}__tracking-id`}
              onChange={value => this.props.onFormChange('tracking_id', value)}
              placeholder={strings.Task.form.additionalInfo.trackingIdHint}
              value={form.tracking_id}
            />
          </Components.Form.Block>
        ) : false}
      </Components.Form.ExpandableContainer>

    );
  }

  _renderSkill(strings, skills, fieldName) {
    return (
      <React.Fragment>
        <Components.Form.Divider size="SMALL" />
        <Components.Form.Block level={1}>
          {strings.label}
        </Components.Form.Block>
        <Components.Form.Block level={1}>
          <Components.Input.Tag
            allowClear
            onChange={value => this.props.onFormChange(fieldName, value)}
            options={skills.map(skill => ({
              text: skill,
              value: skill,
            }))}
            placeholder={strings.placeholder}
            showEllipsis
            tagClassName="vf-driver__edit__tag"
            value={this.props.form[fieldName]}
          />
        </Components.Form.Block>
      </React.Fragment>
    );
  }

  _renderSkillsList = () => {
    if (!this._isSkillsSubscribed()) {
      return null;
    }

    const { skills } = this.props.constant;
    const strings = this.props.strings.Task.form.specificationRequirements;

    return (
      <React.Fragment>
        <Components.Window.Header>
          <Components.Window.Header.Title>
            {strings.title}
          </Components.Window.Header.Title>
          <Components.Window.Description>
            {strings.description}
          </Components.Window.Description>
        </Components.Window.Header>
        {this._renderSkill(strings.driverSpecifications, skills.driver_skills, 'driver_skill_list')}
        {this._renderSkill(strings.vehicleSpecifications, skills.vehicle_skills, 'vehicle_skill_list')}
        {this._isPartsSubscribed()
          && this._renderSkill(strings.partSpecifications, skills.vehicle_part_skills, 'vehicle_part_skill_list')}
      </React.Fragment>
    );
  }

  render() {
    const stringsPickupInfo = this.props.strings.Job.form.pickupInfo;
    const { error, form, strings } = this.props;
    return (
      <div>
        <Components.Form.MobileMainHeader
          iconClassName={this.props.data.job?.job_type === 'pickup' ? 'versa-arrow-up'
            : 'versa-arrow-down'}
          iconText=""
          text={this.props.data.job?.job_type === 'pickup' ? stringsPickupInfo.pickupFrom
            : stringsPickupInfo.deliveryTo}
        />
        <Components.Form.Block fontWeight="BOLD" level={1}>
          {this.props.data.guid}
        </Components.Form.Block>

        <Components.Form.InputGroup>
          <Components.Form.Block
            iconClassName="versa-person"
            isInputIcon
            level={0}
          >
            <Components.Input.Select
              error={error.billing_account}
              id={`${this.props.id}__account-name`}
              onChange={value => this.props.onFormChange('billing_account_id', value)}
              options={this._getAccountOptions()}
              placeholder={strings.Task.form.mainHeader.accountHint}
              value={form.billing_account_id}
            />
          </Components.Form.Block>
        </Components.Form.InputGroup>

        <Components.Form.InputGroup>
          <Components.Form.Block
            iconClassName="versa-call"
            isInputIcon
            level={0}
          >
            <Components.Input.Textbox
              error={error.address && error.address.contact_person}
              id={`${this.props.id}__contact-person`}
              onChange={value => this.props.onFormChange('address_attributes.contact_person', value)}
              placeholder={strings.Job.form.additionalInfo.contactPersonHint}
              value={(form.address_attributes || {}).contact_person}
            />
          </Components.Form.Block>
          <Components.Form.Block
            iconClassName=""
            iconText=""
            isInputIcon
            level={0}
          >
            <Components.Input.Textbox
              error={error.address && error.address.contact_number}
              id={`${this.props.id}__contact-number`}
              onChange={value => this.props.onFormChange('address_attributes.contact_number', value)}
              placeholder={strings.Job.form.additionalInfo.contactNumberHint}
              value={(form.address_attributes || {}).contact_number}
            />
          </Components.Form.Block>
          <Components.Form.Block
            iconClassName=""
            iconText=""
            isInputIcon
            level={0}
          >
            <Components.Input.Textbox
              error={error.address && error.address.email}
              id={`${this.props.id}__email`}
              onChange={value => this.props.onFormChange('address_attributes.email', value)}
              placeholder={strings.Job.form.additionalInfo.contactEmailHint}
              value={(form.address_attributes || {}).email}
            />
          </Components.Form.Block>
        </Components.Form.InputGroup>

        <JobModuleCustomAddress
          addressList={this._getAddresses()}
          error={error.address}
          iconClassName="versa-marker-plain"
          id={`${this.props.id}__custom-address`}
          onChange={(value, shouldChange) => this.props.onFormChange(
            'address_attributes', value, undefined, undefined, shouldChange,
          )}
          value={form.address_attributes || {}}
        />

        <Components.Form.Divider />

        <JobModuleCustomDateTime
          error={error}
          id={`${this.props.id}__custom-date-time`}
          onChange={value => this.props.onFormChange(null, value)}
          value={form}
        />

        <Components.Form.Divider size="LARGE" />

        {/* Additional Info */}

        {this._renderAdditionalInfo()}
        <Components.Form.Divider />

        {this._renderCustomInfo()}
        {this._renderSkillsList()}

        <MeasurementModule.Edit
          data={form.measurements_attributes}
          error={error.measurements || []}
          id={`${this.props.id}__measurement`}
          onFormChange={(value, index, isDelete) => this.props.onFormChange(
            'measurements_attributes', value, index, isDelete,
          )}
          ref={(c) => { this.measurementEdit = c; }}
        />

        <Components.Form.Divider />
      </div>
    );
  }
}

TaskEdit.propTypes = {
  account: PropTypes.shape({
    addons_setting: PropTypes.shape({
      custom_field: PropTypes.number,
      skills: PropTypes.number,
      parts_and_config: PropTypes.number,
      use_own_epod: PropTypes.number,
    }),
  }).isRequired,
  billingAccounts: PropTypes.objectOf(PropTypes.shape({
    addresses: PropTypes.arrayOf(PropTypes.shape()),
  })),
  constant: PropTypes.shape({
    billing_accounts: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      driver_skills: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
      })),
      vehicle_skills: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
      })),
      vehicle_part_skills: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
      })),
    })),
    jobs: PropTypes.shape({
      states: PropTypes.arrayOf(PropTypes.string),
      tags: PropTypes.arrayOf(PropTypes.string),
    }),
    skills: PropTypes.shape({
      driver_skills: PropTypes.arrayOf(PropTypes.string),
      vehicle_skills: PropTypes.arrayOf(PropTypes.string),
      vehicle_part_skills: PropTypes.arrayOf(PropTypes.string),
    }),
    tasks: PropTypes.shape({
      states: PropTypes.arrayOf(PropTypes.string),
      tags: PropTypes.arrayOf(PropTypes.string),
      time_types: PropTypes.arrayOf(PropTypes.string),
    }),
  }),
  customFieldGroups: PropTypes.shape(),
  customer: PropTypes.shape({
    billing_accounts: PropTypes.arrayOf({
      addresses: PropTypes.arrayOf(PropTypes.shape()),
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  }).isRequired,
  data: PropTypes.shape({
    form: PropTypes.shape(),
    guid: PropTypes.string,
    custom_field_group: PropTypes.shape(),
    job: PropTypes.shape(),
    job_type: PropTypes.string,
  }).isRequired,
  dispatch: PropTypes.func,
  error: PropTypes.shape({
    address: PropTypes.shape(),
    billing_account: PropTypes.shape(),
    custom_fields: PropTypes.arrayOf(PropTypes.string),
    expected_cod: PropTypes.arrayOf(PropTypes.string),
    invoice_number: PropTypes.arrayOf(PropTypes.string),
    measurements: PropTypes.arrayOf(PropTypes.string),
    price: PropTypes.arrayOf(PropTypes.string),
    time_to: PropTypes.arrayOf(PropTypes.string),
    time_from: PropTypes.arrayOf(PropTypes.string),
    time_type: PropTypes.arrayOf(PropTypes.string),
    tag_list: PropTypes.arrayOf(PropTypes.string),
    tracking_id: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  form: PropTypes.shape({
    billing_account_id: PropTypes.number,
    address_attributes: PropTypes.shape(),
    invoice_number: PropTypes.string,
    price: PropTypes.number,
    remarks: PropTypes.string,
    tag_list: PropTypes.arrayOf(PropTypes.string),
    driver_skill_list: PropTypes.arrayOf(PropTypes.string),
    vehicle_skill_list: PropTypes.arrayOf(PropTypes.string),
    vehicle_part_skill_list: PropTypes.arrayOf(PropTypes.string),
    photos_attributes: PropTypes.arrayOf(PropTypes.shape()),
    epod_attachments_attributes: PropTypes.arrayOf(PropTypes.shape()),
    expected_cod: PropTypes.number,
    tracking_id: PropTypes.string,
    measurements_attributes: PropTypes.arrayOf(PropTypes.shape()),
    custom_field_group_id: PropTypes.oneOfType([
      PropTypes.string, PropTypes.number,
    ]),
  }).isRequired,
  id: PropTypes.string,
  isNewTask: PropTypes.bool.isRequired,
  myjobsSetting: PropTypes.shape({
    show_additional_info: PropTypes.bool,
    show_price: PropTypes.bool,
    show_invoice_number: PropTypes.bool,
    show_note: PropTypes.bool,
    show_tags: PropTypes.bool,
    show_tracking_id: PropTypes.bool,
  }).isRequired,
  onFormChange: PropTypes.func.isRequired,
  optionCustomFieldGroups: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  })),
  ourLocations: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  strings: PropTypes.shape({
    Job: PropTypes.shape({
      form: PropTypes.shape({
        additionalInfo: PropTypes.shape({
          remarksHint: PropTypes.string,
          tagHint: PropTypes.string,
          contactPersonHint: PropTypes.string,
          contactNumberHint: PropTypes.string,
          contactEmailHint: PropTypes.string,
        }),
        pickupInfo: PropTypes.shape({
          pickupFrom: PropTypes.string,
          deliveryTo: PropTypes.string,
        }),
      }),
    }),
    Task: PropTypes.shape({
      form: PropTypes.shape({
        specificationRequirements: PropTypes.shape({
          title: PropTypes.string,
          description: PropTypes.string,
          driverSpecifications: PropTypes.shape({
            label: PropTypes.string,
            placeholder: PropTypes.string,
          }),
          vehicleSpecifications: PropTypes.shape({
            label: PropTypes.string,
            placeholder: PropTypes.string,
          }),
          partSpecifications: PropTypes.shape({
            label: PropTypes.string,
            placeholder: PropTypes.string,
          }),
        }),
        customInfo: PropTypes.shape(),
        additionalInfo: PropTypes.shape({
          epodAttachment: PropTypes.shape({
            attachFile: PropTypes.string,
            button: PropTypes.string,
            invalidType: PropTypes.string,
            title: PropTypes.string,
          }),
          cod: PropTypes.shape({
            title: PropTypes.string,
            expectedCODHint: PropTypes.string,
          }),
          invoiceNumberHint: PropTypes.string,
          priceHint: PropTypes.string,
          trackingIdHint: PropTypes.string,
          title: PropTypes.string,
        }),
        mainHeader: PropTypes.shape({
          accountHint: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
};

TaskEdit.defaultProps = {
  billingAccounts: [],
  constant: {},
  customFieldGroups: {},
  id: 'vf-task__edit',
  optionCustomFieldGroups: [],
  dispatch: {},
};

const mapStateToProps = (state) => {
  const {
    account, billingAccount, profile, ourLocation,
  } = state;
  return {
    account: account.account,
    billingAccounts: billingAccount.billingAccounts,
    myjobsSetting: (profile.profile || {}).myjobs_setting,
    ourLocations: ourLocation.ourLocationIds.map(id => ourLocation.ourLocations[id]) || [],
  };
};

export default connect(mapStateToProps)(translate('')(TaskEdit));
